import PopupCarouselControls from './PopupCarouselControls';

export default PopupCarouselControls;
